<template>
  <div class="papers">
    <div class="papers-title slidetop" data-scroll data-scroll-call="animateMove">
      <strong>成为讲师</strong>
      <small>CALL FOR PAPERS</small>
    </div>
    <div class="papers-text slidetop detay1" data-scroll data-scroll-call="animateMove">
      <p>RTE 2022 实时互联网大会向全球征集演讲嘉宾，诚挚邀请各界人士推荐演讲嘉宾或自荐加入到实时互动议题的讨论当中！大会组委会将对每一位报名演讲嘉宾的信息进行综合评估，通过评估审核的嘉宾将收到正式邀请函，敬请耐心等候。</p>
      <!-- <time>征集时间：2022年7月1日至8月31日</time> -->
      <a target="_block" href="https://www.wenjuan.com/s/UZBZJvLMAfM/">申请演讲</a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
@import url("@/assets/css/home/index.less");
</style>
